import {SerializedStyles} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import {StaticDatePicker, StaticDatePickerProps} from '@mui/x-date-pickers';
import React from 'react';

import {GetStylesFunction} from 'src/js/common/types';

interface OwnProps extends StaticDatePickerProps<Date> {
  inputCss?: SerializedStyles;
  disableDays?: boolean;
  disablePast?: boolean;
}

type Props = OwnProps;

export const DlMuiDatePicker: React.FC<Props> = (props) => {
  const {children, slotProps, inputCss, disableDays, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});

  return (
    <StaticDatePicker
      data-name={'dl-mui-date-picker--static-date-picker'}
      slotProps={{
        toolbar: {hidden: true},
        ...slotProps,
      }}
      views={disableDays ? ['year', 'month'] : ['month', 'year', 'day']}
      {...restProps}
    />
  );
};

DlMuiDatePicker.displayName = 'DlMuiDatePicker';

const getStyles: GetStylesFunction = (options) => ({
  select: css`
    height: 24px;
    width: 61px;
    color: ${options?.theme?.palette.custom.coolGray['900']};
    border: 1px solid ${options?.theme?.palette.custom.coolGray['100']};
    border-radius: 4px;
    ${options?.params?.inputCss ?? ''};
  `,
});
